import {
  API_TYPES,
  CONTRACTOR_BADGE_VERIFICATION_STATUS,
  updateContractorBadgeVerificationBodySchema,
  updateContractorBadgeVerificationResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CONTRACTOR_BADGE_VERIFICATIONS_URL } from "../constants";
import { invalidateContractorBadgeVerification } from "./useGetContractorBadgeVerification";
import { INVALIDATE_ALL_BADGE_QUERIES_KEY } from "./useGetWorkerBadgeVerifications";

interface MarkBadgeVerificationResultSeenParams {
  verificationId: string;
  shiftId: string;
}

export function useMarkBadgeVerificationResultSeen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ verificationId, shiftId }: MarkBadgeVerificationResultSeenParams) => {
      const response = await patch({
        url: `${CONTRACTOR_BADGE_VERIFICATIONS_URL}/${verificationId}`,
        data: {
          data: {
            type: API_TYPES.contractorBadgeVerification,
            id: verificationId,
            attributes: {
              status: CONTRACTOR_BADGE_VERIFICATION_STATUS.ACKNOWLEDGED,
            },
          },
        },
        requestSchema: updateContractorBadgeVerificationBodySchema,
        responseSchema: updateContractorBadgeVerificationResponseSchema,
      });

      await invalidateContractorBadgeVerification(queryClient, shiftId);
      await queryClient.invalidateQueries(INVALIDATE_ALL_BADGE_QUERIES_KEY);

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.BADGE_VERIFICATION_UPDATE_FAILURE,
      userErrorMessage: "Something went wrong while acknowledging your badge verification result",
    },
  });
}
